import type { FC } from 'react';
import { memo } from 'react';

import classNames from 'classnames';
import { connect as formikConnect } from 'formik';
import isNil from 'lodash/isNil';
import { branch, compose, renderNothing } from 'recompact';

import styles from './styles.module.scss';

const componentHasNoErrors = props =>
  !(props.customErrorMarkup || props.errors?._generic || props.formik?.errors?._generic);

const renderNothingIfNoErrorProvided = branch(componentHasNoErrors, renderNothing);

const Wrapper: FC = ({ children }) => <div className={classNames(styles.component, styles._specific)}>{children}</div>;

const GenericError = ({ errors, formik, customErrorMarkup }) => {
  if (isNil(errors) && isNil(customErrorMarkup) && !formik) {
    console.warn('GenericError requires either an `errors` prop or Formik context');
  }

  if (customErrorMarkup) {
    return <Wrapper>{customErrorMarkup}</Wrapper>;
  }

  const genericError = isNil(errors) ? formik?.errors?._generic : errors?._generic;

  return <Wrapper>{genericError}</Wrapper>;
};

export default compose(formikConnect, memo, renderNothingIfNoErrorProvided)(GenericError);
